import { format } from 'date-fns';

import { defaultFormat } from '../../assets/contants/dates-fns';
import { formatPlainDate, isPlainDate } from '../../core/services/plain-date';

export const currentDateTimeAsIso = () => {
  return new Date(Date.now()).toISOString();
};

/**
 * A `YYYY-MM-DD` input is a calendar day, not an instant, and must render as the same day for
 * every viewer. `new Date('2026-08-25')` parses as UTC midnight, so formatting it with local
 * getters lands on Aug 24 west of UTC — that is PRO-1069.
 */
export const formatDate = (date: string, dateFormat?: string) => {
  const pattern = dateFormat ? dateFormat : defaultFormat;

  if (isPlainDate(date)) {
    return formatPlainDate(date, pattern);
  }

  return format(new Date(date), pattern);
};
